"use client";

// Pub-sub signal so the Dock can open MiniPlayer's drawer (sibling components).

import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

export function setMiniDrawerOpen(value: boolean): void {
  if (open === value) return;
  open = value;
  for (const l of listeners) l();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return open;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useMiniDrawerOpen(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
